import { FC } from 'react';
import { useDisclosure } from '@chakra-ui/react';
import { GetCustomUrlResponse } from '@frx/frx-services';
import { Modal } from '../modal';
import { ConfirmationStep } from './ConfirmationStep';
import { useIsMobile } from '../../hooks';
import { SaveUrlStep } from './SaveUrlStep';

interface CustomUrlModalProps {
  headingLabel?: string;
  data: GetCustomUrlResponse;
  errorMessage?: string;
  isError: boolean;
  isOpen: boolean;
  isSaving: boolean;
  onSave: (url: string) => void;
  onStepClose: () => void;
  pageName: string;
}

export const CustomUrlModal: FC<CustomUrlModalProps> = (props) => {
  const isMobile = useIsMobile();
  const {
    headingLabel,
    data,
    errorMessage,
    isError,
    isOpen,
    isSaving,
    onSave,
    onStepClose,
    pageName,
  } = props;
  const { onClose } = useDisclosure();

  const urlPrefix = data?.shortcutItem?.prefix ?? '';
  const customUrl = data?.shortcutItem?.text ?? '';
  const vanityUrl = data?.shortcutItem?.url ?? '';

  return (
    <Modal
      size={isMobile ? 'xs' : 'sm'}
      onClose={() => {
        onClose();
        onStepClose();
      }}
      trackingLabel="customizeUrlModal"
      isOpen={isOpen}
    >
      {pageName === 'create' ? (
        <SaveUrlStep
          headingLabel={headingLabel}
          customUrl={customUrl}
          urlPrefix={urlPrefix}
          isSaving={isSaving}
          onSave={(e: any) => {
            onSave(e);
          }}
          isError={isError}
          errorMessage={errorMessage}
        />
      ) : (
        <ConfirmationStep customUrl={vanityUrl} />
      )}
    </Modal>
  );
};
